/**
 * /src/charts/bar-chart-race/initializer.js
 * 【新仕様 v2.0 対応版】
 * - Role属性ベースの要素取得
 * - 複数インスタンス対応
 */
import { BarChartRace } from './BarChartRace.ts';

document.addEventListener('DOMContentLoaded', () => {
    // --- 1. ターゲット要素の取得 (新仕様: Role属性ベース) ---
    // data-chart-role="container" かつ data-chart-type="bar-chart-race" の要素を検索
    const chartWrappers = document.querySelectorAll('[data-chart-role="container"][data-chart-type="bar-chart-race"]');

    chartWrappers.forEach(wrapper => {
        const initializeChart = async () => {
            // --- 2. 内部要素の取得 (Role属性) ---
            const chartArea = wrapper.querySelector('[data-chart-role="chart-area"]');
            const controlsContainer = wrapper.querySelector('[data-chart-role="controls"]');

            if (!chartArea || !controlsContainer) {
                console.error('[bar-chart-race] Error: Required DOM elements (role=chart-area/controls) not found.');
                return;
            }

            if (chartArea._chartInstance) {
                return; // 二重初期化防止
            }

            // --- 3. 設定値の取得 (data属性) ---
            // PHPの shortcode-helpers.php が chart-area に出力した属性を取得
            const dataset = chartArea.dataset;
            const config = {
                protobufSourceUrl: dataset.protobufSourceUrl || null,
                mappingJsonSourceUrl: dataset.mappingJsonSourceUrl || null,
                topN: dataset.topN ? parseInt(dataset.topN, 10) : undefined,
                durationPerFrame: dataset.durationPerFrame ? parseInt(dataset.durationPerFrame, 10) : undefined,
                transitionDuration: dataset.transitionDuration ? parseInt(dataset.transitionDuration, 10) : undefined,
                barHeight: dataset.barHeight ? parseInt(dataset.barHeight, 10) : undefined,
                labelFontSize: dataset.labelFontSize || undefined,
                dateDisplayFormat: dataset.dateDisplayFormat || undefined,
                dateDisplayFontSize: dataset.dateDisplayFontSize ? parseInt(dataset.dateDisplayFontSize, 10) : undefined,
                colorBy: dataset.colorBy || undefined,
            };

            // undefinedな値を除外
            const filteredConfig = Object.fromEntries(Object.entries(config).filter(([, v]) => v !== undefined));

            // --- 4. インスタンス生成 ---
            console.log('[bar-chart-race] Creating instance...');
            const chart = new BarChartRace(chartArea, filteredConfig);
            chartArea._chartInstance = chart;
            chartArea.dataset.chartInstance = 'true';

            // --- 5. UI要素の動的生成 ---
            // Role属性ベースの場合、HTMLの中身はJSで生成するのが基本ルール
            controlsContainer.innerHTML = `
                <button class="play-pause-button" aria-label="再生/一時停止"></button>
                <input type="range" class="time-slider" min="0" max="0" value="0" step="0.01">
                <span class="current-date-display"></span>
            `;

            const playPauseButton = controlsContainer.querySelector('.play-pause-button');
            const timeSlider = controlsContainer.querySelector('.time-slider');
            // ※日付表示(current-date-display)はCSSに定義があるため要素を追加したが、
            // 現行のBarChartRace.tsはSVG内に日付を描画するため、ここへのテキストセットは未実装。
            
            // ユーザー操作検知用
            let userHasInteracted = false;
            const handleUserInteraction = () => {
                if (!userHasInteracted) {
                    userHasInteracted = true;
                    if (chart && chart.config) {
                        chart.config.autoplay = false;
                    }
                }
            };

            // --- 6. イベントリスナー ---
            let isSeeking = false;

            if (playPauseButton) {
                playPauseButton.addEventListener('click', () => {
                    handleUserInteraction();
                    chart.togglePlayPause();
                });
            }

            if (timeSlider) {
                // マウス操作
                timeSlider.addEventListener('mousedown', () => {
                    isSeeking = true;
                    if (chart.getCurrentProgressState().isPlaying) {
                        chart.pause();
                    }
                });
                
                // タッチ操作対応
                timeSlider.addEventListener('touchstart', () => {
                    isSeeking = true;
                    if (chart.getCurrentProgressState().isPlaying) {
                        chart.pause();
                    }
                }, { passive: true });

                const onSeekEnd = () => { isSeeking = false; };
                timeSlider.addEventListener('mouseup', onSeekEnd);
                timeSlider.addEventListener('touchend', onSeekEnd);

                timeSlider.addEventListener('input', (event) => {
                    if (isSeeking) {
                        handleUserInteraction();
                        // stepが0.01なのでparseFloat
                        chart.seek(parseFloat(event.target.value));
                    }
                });
            }

            // --- 7. UI更新コールバック ---
            chart.onUpdateUI(state => {
                // 再生中クラスはラッパーに付与 (共通CSS .c-chart-container.is-playing でアイコン切り替え)
                wrapper.classList.toggle('is-playing', state.isPlaying);
                
                const totalUiFrames = state.totalUiFrames > 0 ? state.totalUiFrames - 1 : 0;
                
                if (timeSlider) {
                    // スライダーの最大値を更新 (基本固定だが念のため)
                    // 文字列比較になるのを防ぐため parseFloat
                    if (parseFloat(timeSlider.max) !== totalUiFrames) {
                        timeSlider.max = totalUiFrames;
                    }

                    // シーク中でなければ値を更新
                    if (!isSeeking) {
                        timeSlider.value = state.currentUiFrame;
                    }
                }
            });

            // --- 8. 初期化実行 ---
            try {
                await chart.init();
            } catch (error) {
                console.error('[bar-chart-race] Initialization failed:', error);
            }
        };

        initializeChart();
    });
});